import {Component, Input} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';

@Component({
  selector: 'app-modal-leistung-state-change',
  templateUrl: './modal-leistung-state-change.component.html',
  styles: [
  ]
})
export class ModalLeistungStateChangeComponent extends ExcTranslation {
  @Input() data: {
    leID: string;
    headerText: string;
    description: string;
    commentRequired: boolean;
    relation: any;
  } = {leID: '', headerText: '', description: '', commentRequired: false, relation: undefined};

  comment = '';
  minCommentLength = 10;
  billingDate: number;

  constructor(
    public modal: ExgModalService,
    private excRestService: ExcRestService
  ) {
    super();


    this.billingDate = Date.now();
  }

  isRequired(): boolean {
    return this.data.commentRequired && this.comment.length < this.minCommentLength;
  }

  valid(): boolean {
    if (this.data.commentRequired) {
      return this.comment.length >= this.minCommentLength;
    }
    return this.billingDate <= Date.now();
  }

  save(): void {
    if (!this.valid()) {
      this.modal.showToast(
        this.getRessource('CommentRequired', {min: this.minCommentLength}),
        'md-toast',
        'fas fa-exclamation'
      );
      return;
    }
    this.excRestService.post(
      this.excRestService.computeUrl('LeistungserfassungKommentarC', {ID: this.data.leID}),
      {ID: this.data.leID, Message: this.comment, Relation: this.data.relation},
      {}
    ).subscribe(() => {
      this.modal.action({comment: this.comment, billingDate: this.billingDate});
      this.modal.close();
    });
  }

  cancel(): void {
    this.modal.close();
  }

}
